import { IconComponentProps } from '../IconTypes';

const ErrorCircleSmall = ({ className }: IconComponentProps) => (
  <svg className={className} fill="none" height="12" viewBox="0 0 12 12" width="12" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1063_6255)">
      <path
        clipRule="evenodd"
        d="M12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6ZM5.25 2.75C5.25 2.33579 5.58579 2 6 2C6.41421 2 6.75 2.33579 6.75 2.75V6.75C6.75 7.16421 6.41421 7.5 6 7.5C5.58579 7.5 5.25 7.16421 5.25 6.75V2.75ZM6 8.5C5.58579 8.5 5.25 8.83579 5.25 9.25C5.25 9.66421 5.58579 10 6 10C6.41421 10 6.75 9.66421 6.75 9.25C6.75 8.83579 6.41421 8.5 6 8.5Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="clip0_1063_6255">
        <rect fill="none" height="12" width="12" />
      </clipPath>
    </defs>
  </svg>
);

export default ErrorCircleSmall;
